import { FormAnswer } from '@models/membership/Form'
import { useAppSelector } from '@store/hooks'
import { selectFormAnswerById } from '@store/membership/FormAnswerReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Flex, Space, Typography } from 'antd'
import dayjs from 'dayjs'
import { FC, useMemo } from 'react'

const { Text } = Typography

type Props = SBModelComponent<FormAnswer> & {}

const FormAnswerAvatar: FC<Props> = ({ id, model }) => {
  const item = model ?? useAppSelector(selectFormAnswerById(id!))

  const answerValue: string | null = useMemo(() => {
    if (!item || !item.answer) return null

    if (item.item?.name === 'birth_date') {
      return `${dayjs(item.answer).format('DD MMMM YYYY')} (${dayjs().diff(dayjs(item.answer), 'year')} years old)`
    }
    return item.answer
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Flex vertical>
      {answerValue && <Text>{answerValue}</Text>}
      <Space wrap>
        {item.itemOptions?.map((itemOption) => (
          <Text key={itemOption.id} code>
            {itemOption.en.label}
          </Text>
        ))}
      </Space>
    </Flex>
  )
}

type FormAnswerAvatarType = { Avatar: typeof FormAnswerAvatar }

export { FormAnswerAvatar, type FormAnswerAvatarType }
